import { Http } from "./http.init";
import { BaseService } from "./base.service";
import { assert } from "@/core";
import { AbilityBuilder } from "@casl/ability";
import { AuthService } from "./auth.service";
import $store from "../store";

export class UserService extends BaseService {
  constructor() {
    super("users");
  }
  // static async create(payload = {}) {
  //   assert.object(payload, { required: true });
  //   const response = await new Http({
  //     auth: true,
  //     headers: { "Content-Type": "multipart/form-data" }
  //   }).post(`${this.entity}`, {
  //     payload
  //   });
  //   return response.data;
  // }
  // static async update(id, payload = {}) {
  //   assert.id(id, { required: true });
  //   assert.object(payload, { required: true });
  //
  //   const response = await new Http({
  //     auth: true,
  //     headers: { "Content-Type": "multipart/form-data" }
  //   }).put(`${this.entity}/${id}`, payload);
  //   return response.data;
  // }

  static async getRoles(payload) {
    const response = await new Http({ auth: true }).get(`/roles`, {
      params: payload
    });
    return response.data;
  }
  static async lockUser(id, payload = {}) {
    assert.id(id, { required: true });
    assert.object(payload, { required: true });

    const response = await new Http({ auth: true }).post(
      `/user-locked/${id}`,
      payload
    );
    return response.data;
  }
  static async unlockUser(id) {
    assert.id(id, { required: true });
    const response = await new Http({ auth: true }).delete(
      `/user-locked/${id}`
    );
    return response.data;
  }
  static async getLockedUserById(id) {
    assert.id(id, { required: true });
    const response = await new Http({ auth: true }).get(`/user-locked/${id}`);
    return response.data;
  }
  static async setAbility() {
    // const { can, rules } = new AbilityBuilder(undefined);
    const response = await AuthService.getUserInfo();
    if (!response) return;
    $store.commit("auth/SET_USER_INFO", response);
    // $store.commit("auth/SET_ROLES", response.roles);
    // roles.forEach(role => {
    //   if (role.name !== "Member") this.onlyMember = false;
    //   can(role.name);
    // });
    // this.$ability.update(rules);
  }
}
